<!--
 * @Description: 录音组件
 * @Author: 房旭
 * @LastEditors: 房旭
 * @Date: 2019-02-23 14:10:30
 * @LastEditTime: 2019-05-10 09:17:01
 -->
<template>
    <div class="recording_item">
        <icon type="ios-play" @click="clickPlay" v-show="!isPlay" style="cursor: pointer;" color="#0094e9" :size="18" />
        <icon type="ios-pause" @click="clickPause" v-show="isPlay" style="cursor: pointer;" color="#0094e9" :size="18" />
        <div class="progress">
            <div :style="{width: load, maxWidth: '100%'}" class="load"></div>
            <div :style="{width: play, maxWidth: '100%'}" class="inner"></div>
        </div>
        <div class="time">{{currentTime}}</div>
        <audio ref="audio" :src="sound.fileurl"></audio>
        <i v-if="showDelete" @click="clickDelete" class="iconfont icon-shanchu1"></i>
    </div>
</template>

<script>
export default {
    props: {
        sound: Object,
        showDelete: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isPlay: false,
            audio: null,
            duration: 0,
            currentTime: "0:00",
            currentDuration: 0,
            load: 0,
            play: 0
        };
    },
    computed: {},
    methods: {
        clickPlay() {
            this.audio.play();
            this.isPlay = true;
        },
        clickDelete() {
            this.$emit("on-delete", this.sound);
            this.audio.pause();
        },
        clickPause() {
            this.audio.pause();
            this.isPlay = false;
        },
        secondsToMin(seconds) {
            let second = seconds % 60;

            let min = Math.floor(seconds / 60);
            if (second <= 0) {
                second = 0;
            }
            if (second < 10) {
                second = "0" + second;
            }
            if (min < 0) {
                min = 0;
            }

            return `${min}:${second}`;
        }
    },
    mounted() {
        this.audio = this.$refs.audio;
        this.audio.addEventListener("play", () => {
            this.$refs.audio.play()
        });
        this.audio.addEventListener("ended", () => {
            this.currentTime = this.secondsToMin(this.duration);
            this.isPlay = false;
            this.play = 0;
        });
        this.audio.ontimeupdate = () => {
            this.audio.readyState == 4;
            this.currentTime = this.secondsToMin(
                this.duration - Math.ceil(this.audio.currentTime)
            );
            this.play = (this.audio.currentTime / this.duration) * 100 + "%";

            this.load =
                (this.audio.buffered.end(0) / this.duration) * 100 + "%";
        };
        this.audio.addEventListener("canplay", () => {

            this.duration = Math.floor(this.audio.duration);
            this.currentTime = this.secondsToMin(this.duration);
        });
    }
};
</script>

<style scoped lang="less">
.recording_item {
    position: relative;
    width: 100px;
    height: 30px;
    box-sizing: border-box;
    border: 1px solid #0094e9;
    border-radius: 15px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .progress {
        width: 65%;
        height: 2px;
        background: #bae6ff;
        position: relative;

        .load {
            height: 2px;
            background: #8bd5ff;
            width: 0;
            position: absolute;
            left: 0;
        }

        .inner {
            width: 0;
            height: 100%;
            background: #0095e9;
            z-index: 9;
            position: absolute;
            left: 0;

            .doin {
                position: absolute;
                height: 10px;
                width: 10px;
                border-radius: 50%;
                top: 50%;
                margin-top: -5px;
                right: -5px;
                background: #0095e9;
                cursor: pointer;
            }
        }
    }

    .time {
        color: #0094e9;
        font-size: 12px;
    }

    &:nth-child(1),
    &:nth-child(2) {
        margin: 0;
    }
}

// }
.icon-shanchu1 {
    position: absolute;
    font-size: 16px;
    color: #ff2a00;
    right: -4px;
    cursor: pointer;
    top: -16px;
}
</style>